<mat-icon class="filter cursor-pointer on-disabled" [matMenuTriggerFor]="filtersMenu">tune</mat-icon>

<mat-menu #filtersMenu="matMenu" class="fit-content-menu">
  <div class="period-filters" (click)="$event.stopPropagation()">
    @if (showPeriod()) {
      <div class="filter-group">
        <span class="on-disabled caption">{{ 'dashboard_ui.granularite' | trans }}</span>
        <mat-button-toggle-group [value]="period()" (change)="onPeriodChange($event.value)" hideSingleSelectionIndicator>
          <mat-button-toggle value="j">{{ 'dashboard_ui.jour' | trans }}</mat-button-toggle>
          <mat-button-toggle value="s">{{ 'dashboard_ui.semaine' | trans }}</mat-button-toggle>
          <mat-button-toggle value="m">{{ 'dashboard_ui.mois' | trans }}</mat-button-toggle>
          <mat-button-toggle value="a">{{ 'dashboard_ui.annee' | trans }}</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    }

    @if (showTimeScale()) {
      <div class="filter-group">
        <span class="on-disabled caption">{{ 'dashboard_ui.echelle' | trans }}</span>
        <mat-button-toggle-group [value]="timeScale()" (change)="onTimeScaleChange($event.value)" hideSingleSelectionIndicator>
          <mat-button-toggle value="1 m">1 m</mat-button-toggle>
          <mat-button-toggle value="3 m">3 m</mat-button-toggle>
          <mat-button-toggle value="6 m">6 m</mat-button-toggle>
          <mat-button-toggle value="YTD">YTD</mat-button-toggle>
          <mat-button-toggle value="EX">Exercice</mat-button-toggle>
          <mat-button-toggle value="1 a">1 a</mat-button-toggle>
          <mat-button-toggle value="5 a">5 a</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    }

    @if (showComparison()) {
      <div class="filter-group">
        <span class="on-disabled caption">{{ 'dashboard_ui.comparaison' | trans }}</span>
        <mat-button-toggle-group [value]="comparison()" (change)="onComparisonChange($event.value)" hideSingleSelectionIndicator>
          <mat-button-toggle value="">{{ 'dashboard_ui.aucune' | trans }}</mat-button-toggle>
          <mat-button-toggle value="n-1">{{ 'dashboard_ui.n_moins_1' | trans }}</mat-button-toggle>
          <mat-button-toggle value="previous">{{ 'dashboard_ui.periode_precedente' | trans }}</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    }
  </div>
</mat-menu>
